import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { StyledInput } from './regional-risk-filter-search.styles';

interface RegionalRiskFilterSelectSearchProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  className?: string;
}

const RegionalRiskFilterSelectSearch = ({ onChange, value, className }: RegionalRiskFilterSelectSearchProps) => {
  const [t] = useTranslation();

  return (
    <StyledInput
      className={className}
      size='large'
      placeholder={t('general.search')}
      onChange={onChange}
      value={value}
      prefix={<SearchOutlined />}
      data-testid='regional-risk-filter-search-input'
    />
  );
};

export default RegionalRiskFilterSelectSearch;
